import { render, staticRenderFns } from "./kbSearchInput.vue?vue&type=template&id=24a09af6&scoped=true&"
import script from "./kbSearchInput.vue?vue&type=script&lang=js&"
export * from "./kbSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./kbSearchInput.vue?vue&type=style&index=0&id=24a09af6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a09af6",
  null
  
)

export default component.exports